import {ChangeDetectorRef, Component, Inject, Input} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {pluralize} from "../../../pipes/pluralize/pluralize";
import {TemplateReplacePipe} from "../../../pipes/trmplate-replace/template-replace.pipe";
import {CommonModule} from '@angular/common';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-filter-stars',
  templateUrl: environment.mobile ? './filter-stars.component.mobile.html' : './filter-stars.component.html',
  styleUrls: environment.mobile ? ['./filter-stars.component.mobile.scss'] : ['./filter-stars.component.scss'],
  standalone: true,
  imports: [TemplateReplacePipe, CommonModule],
})
export class FilterStarsComponent {
  @Input() viewValue!: string;
  @Input() count!: number;
  @Input() isActive = false;
  @Input()
  set filterValue(stars: any) {
    this.starsValue = stars;
    this.populateStars();
    if (this.starsValue !== stars) {
      this.cd.markForCheck();
    }
  }
  get filterValue() {
    return this.starsValue;
  }

  private starsValue;
  isStars = true;
  #stars: boolean[] = [false, false, false, false, false];
  messages: any = {};

  countToursMapping(countTours) {
    return {
      'countToursVal': countTours,
      'countToursText': this.toursCountText(countTours),
    }
  }

  constructor(public cd: ChangeDetectorRef,@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) {
    this.messages = {
      'countTours': '{{countToursVal}} {{countToursText}}'
    };
  }

  get stars() {
    return this.#stars;
  }

  get activeStars() {
    return this.#stars.filter((star) => star === true);
  }

  private populateStars() {
    const value = Number(this.filterValue);
    if (!Number.isNaN(value)) {
      for (let index = 0; index < value && index < 5; index++) {
        this.#stars[index] = true;
      }
    } else {
      this.isStars = false;
    }
  }

  public toursCountText(value) {
    return pluralize(value, this.hotelToursPageConfig.translates.plurals.pluralTours);
  }
}
